enum GameState {
  BROWSE,
  LOBBY,
  GAME,
}

export { GameState };
